//----------------------------------
// clear local combatant dupe ranks
//----------------------------------
export default function clearLocalCombatantDupeRanks(combatants) {
  //
  combatants.forEach((c) => {
    c.dupe_rank = false;
  });
  return combatants;
}
